export default {
  lecturer_no: {
    set (value) {
      this.$store.commit('updateLecturerLecturerNo', value)
    },
    get () {
      return this.$store.state.lecturerForm.lecturer_no
    }
  },
  name: {
    set (value) {
      this.$store.commit('updateLecturerName', value)
    },
    get () {
      return this.$store.state.lecturerForm.name
    }
  },
  name_kana: {
    set (value) {
      this.$store.commit('updateLecturerNameKana', value)
    },
    get () {
      return this.$store.state.lecturerForm.name_kana
    }
  },
  published: {
    set (value) {
      this.$store.commit('updateLecturerPublished', value)
    },
    get () {
      return this.$store.state.lecturerForm.published
    }
  },
  lecturer_name: {
    set (value) {
      this.$store.commit('updateLecturerLecturerName', value)
    },
    get () {
      return this.$store.state.lecturerForm.lecturer_name
    }
  },
  birthday: {
    set (value) {
      this.$store.commit('updateLecturerBirthday', value)
    },
    get () {
      return this.$store.state.lecturerForm.birthday
    }
  },
  birthday_publish: {
    set (value) {
      this.$store.commit('updateLecturerBirthdayPublish', value)
    },
    get () {
      return this.$store.state.lecturerForm.birthday_publish
    }
  },
  email: {
    set (value) {
      this.$store.commit('updateLecturerEmail', value)
    },
    get () {
      return this.$store.state.lecturerForm.email
    }
  },
  email_publish: {
    set (value) {
      this.$store.commit('updateLecturerEmailPublish', value)
    },
    get () {
      return this.$store.state.lecturerForm.email_publish
    }
  },
  zipcode: {
    set (value) {
      this.$store.commit('updateLecturerZipcode', value)
    },
    get () {
      return this.$store.state.lecturerForm.zipcode
    }
  },
  prefecture: {
    set (value) {
      this.$store.commit('updateLecturerPrefecture', value)
    },
    get () {
      return this.$store.state.lecturerForm.prefecture
    }
  },
  city: {
    set (value) {
      this.$store.commit('updateLecturerCity', value)
    },
    get () {
      return this.$store.state.lecturerForm.city
    }
  },
  address1: {
    set (value) {
      this.$store.commit('updateLecturerAddress1', value)
    },
    get () {
      return this.$store.state.lecturerForm.address1
    }
  },
  address2: {
    set (value) {
      this.$store.commit('updateLecturerAddress2', value)
    },
    get () {
      return this.$store.state.lecturerForm.address2
    }
  },
  tel: {
    set (value) {
      this.$store.commit('updateLecturerTel', value)
    },
    get () {
      return this.$store.state.lecturerForm.tel
    }
  },
  homepage: {
    set (value) {
      this.$store.commit('updateLecturerHomepage', value)
    },
    get () {
      return this.$store.state.lecturerForm.homepage
    }
  },
  homepage_publish: {
    set (value) {
      this.$store.commit('updateLecturerHomepagePublish', value)
    },
    get () {
      return this.$store.state.lecturerForm.homepage_publish
    }
  },
  facebook: {
    set (value) {
      this.$store.commit('updateLecturerFacebook', value)
    },
    get () {
      return this.$store.state.lecturerForm.facebook
    }
  },
  facebook_publish: {
    set (value) {
      this.$store.commit('updateLecturerFacebookPublish', value)
    },
    get () {
      return this.$store.state.lecturerForm.facebook_publish
    }
  },
  line: {
    set (value) {
      this.$store.commit('updateLecturerLine', value)
    },
    get () {
      return this.$store.state.lecturerForm.line
    }
  },
  line_publish: {
    set (value) {
      this.$store.commit('updateLecturerLinePublish', value)
    },
    get () {
      return this.$store.state.lecturerForm.line_publish
    }
  },
  instagram: {
    set (value) {
      this.$store.commit('updateLecturerInstagram', value)
    },
    get () {
      return this.$store.state.lecturerForm.instagram
    }
  },
  instagram_publish: {
    set (value) {
      this.$store.commit('updateLecturerInstagramPublish', value)
    },
    get () {
      return this.$store.state.lecturerForm.instagram_publish
    }
  },
  blog: {
    set (value) {
      this.$store.commit('updateLecturerBlog', value)
    },
    get () {
      return this.$store.state.lecturerForm.blog
    }
  },
  blog_publish: {
    set (value) {
      this.$store.commit('updateLecturerBlogPublish', value)
    },
    get () {
      return this.$store.state.lecturerForm.blog_publish
    }
  },
  active_area1: {
    set (value) {
      this.$store.commit('updateLecturerActiveArea1', value)
    },
    get () {
      return this.$store.state.lecturerForm.active_area1
    }
  },
  active_area2: {
    set (value) {
      this.$store.commit('updateLecturerActiveArea2', value)
    },
    get () {
      return this.$store.state.lecturerForm.active_area2
    }
  },
  introduction: {
    set (value) {
      this.$store.commit('updateLecturerIntroduction', value)
    },
    get () {
      return this.$store.state.lecturerForm.introduction
    }
  },
  qualification: {
    set (value) {
      this.$store.commit('updateLecturerQualification', value)
    },
    get () {
      return this.$store.state.lecturerForm.qualification
    }
  },
  trigger: {
    set (value) {
      this.$store.commit('updateLecturerTrigger', value)
    },
    get () {
      return this.$store.state.lecturerForm.trigger
    }
  },
  good_things: {
    set (value) {
      this.$store.commit('updateLecturerGoodThings', value)
    },
    get () {
      return this.$store.state.lecturerForm.good_things
    }
  },
  work_images: {
    set (value) {
      this.$store.commit('updateLecturerWorkImages', value)
    },
    get () {
      return this.$store.state.lecturerForm.work_images
    }
  },
  lecturer_status: {
    set (value) {
      this.$store.commit('updateLecturerLecturerStatus', value)
    },
    get () {
      return this.$store.state.lecturerForm.lecturer_status
    }
  },
  lecturer_statuses: {
    set (value) {
      this.$store.commit('updateLecturerLecturerStatuses', value)
    },
    get () {
      return this.$store.state.lecturerForm.lecturer_statuses
    }
  },
  member_status: {
    set (value) {
      this.$store.commit('updateLecturerMemberStatus', value)
    },
    get () {
      return this.$store.state.lecturerForm.member_status
    }
  },
  profile_image: {
    set (value) {
      this.$store.commit('updateLecturerProfileImage', value)
    },
    get () {
      return this.$store.state.lecturerForm.profile_image
    }
  },

  bank: {
    set (value) {
      this.$store.commit('updateLecturerBank', value)
    },
    get () {
      return this.$store.state.lecturerForm.bank
    }
  },
  bank_name: {
    set (value) { this.$store.commit('updateLecturerBankName', value) },
    get () { return this.$store.state.lecturerForm.bank.name }
  },
  bank_branch_store: {
    set (value) { this.$store.commit('updateLecturerBankBranchStore', value) },
    get () { return this.$store.state.lecturerForm.bank.branch_store }
  },
  bank_store_number: {
    set (value) { this.$store.commit('updateLecturerBankStoreNumber', value) },
    get () { return this.$store.state.lecturerForm.bank.store_number }
  },
  bank_deposit_type: {
    set (value) { this.$store.commit('updateLecturerBankDepositType', value) },
    get () { return this.$store.state.lecturerForm.bank.deposit_type }
  },
  bank_account: {
    set (value) { this.$store.commit('updateLecturerBankAccount', value) },
    get () { return this.$store.state.lecturerForm.bank.account }
  },
  bank_holder_name: {
    set (value) { this.$store.commit('updateLecturerBankHolderName', value) },
    get () { return this.$store.state.lecturerForm.bank.holder_name }
  },

  lecturer_name_kana: {
    set (value) { this.$store.commit('updateLecturerLecturerNameKana', value) },
    get () { return this.$store.state.lecturerForm.lecturer_name_kana }
  }
}



// WEBPACK FOOTER //
// ./src/store/lecturer_form/binder.js